/**
 * Jam selesai sesi ⇄ durasi menit.
 *
 * Basis data menyimpan `duration_min`, bukan jam selesai — dan itu bentuk yang
 * benar untuk disimpan: sesi yang digeser tanggalnya tetap berdurasi sama.
 * Tapi bukan bentuk yang benar untuk diketik. Orang menyusun jadwal dengan
 * kalimat "kelasnya jam 09:00 sampai 16:00", bukan "420 menit", dan
 * menerjemahkannya sendiri di kepala adalah kerja yang tidak perlu — kerja yang
 * gampang salah, dan salahnya baru kelihatan setelah jadwalnya terbit.
 *
 * Jadi jam selesai yang diketik, menit yang disimpan. Aturan penerjemahannya
 * tinggal di sini supaya form sesi tunggal dan modal generate kelas tidak bisa
 * berbeda pendapat soal berapa lama sebuah sesi berlangsung.
 */

// Batas yang diterima server (`durationMin` di POST /sessions).
export const DURASI_MIN = 5
export const DURASI_MAKS = 1440

const menitDariJam = (hhmm) => {
  const [j, m] = String(hhmm).split(":").map(Number)
  return Number.isFinite(j) && Number.isFinite(m) ? j * 60 + m : null
}

/**
 * Menit antara dua jam "HH:MM". Mengembalikan null bila salah satunya kosong.
 *
 * Jam selesai yang lebih awal dari jam mulai TIDAK diam-diam dianggap
 * keesokan harinya: 09:00–16:00 yang tertukar jadi 16:00–09:00 adalah salah
 * ketik, dan menerimanya sebagai sesi 17 jam menyembunyikan salah ketik itu
 * sampai jadwalnya sudah dibagikan. Pemanggil memeriksa `valid`.
 */
export function durasiDariJam(mulai, selesai) {
  if (!mulai || !selesai) return { menit: null, valid: true, kosong: true }
  const a = menitDariJam(mulai)
  const b = menitDariJam(selesai)
  if (a == null || b == null) return { menit: null, valid: false, kosong: false }
  const menit = b - a
  if (menit < DURASI_MIN) return { menit, valid: false, kosong: false }
  if (menit > DURASI_MAKS) return { menit, valid: false, kosong: false }
  return { menit, valid: true, kosong: false }
}

/** Jam selesai "HH:MM" dari jam mulai + durasi — untuk mengisi form saat menyunting. */
export function jamSelesaiDari(mulai, durasiMenit) {
  if (!mulai || !durasiMenit) return ""
  const a = menitDariJam(mulai)
  if (a == null) return ""
  const total = a + Number(durasiMenit)
  const pad = (n) => String(n).padStart(2, "0")
  return `${pad(Math.floor(total / 60) % 24)}:${pad(total % 60)}`
}

/** "7 jam 30 menit" — supaya angka yang tersimpan tidak tersembunyi dari yang mengetik. */
export function labelDurasi(menit, id) {
  if (menit == null) return ""
  const j = Math.floor(menit / 60)
  const m = menit % 60
  const bagian = []
  if (j) bagian.push(`${j} ${id ? "jam" : j === 1 ? "hour" : "hours"}`)
  if (m) bagian.push(`${m} ${id ? "menit" : "min"}`)
  return bagian.join(" ") || `0 ${id ? "menit" : "min"}`
}
